import { useQuery } from '@tanstack/react-query';
import { QueryResult } from 'components/query-result/query-result';
import { listInvoicesOptions } from 'generated/api-client/@tanstack/react-query.gen';
import {
  InvoiceFileButton,
  pennylaneKeyOf,
} from 'modules/billing/components/InvoiceFileButton';
import { InvoiceStatusLabel } from 'modules/billing/components/InvoiceStatusLabel';
import React, { FunctionComponent } from 'react';
import { Message, Table } from 'semantic-ui-react';
import {
  formatAmount,
  formatCalendarDate,
  ON_DEMAND_QUERY_OPTIONS,
} from 'utils';

type Props = {
  companyId: number;
};

export const InvoicesTable: FunctionComponent<Props> = ({ companyId }) => {
  const query = useQuery(
    Object.assign(
      listInvoicesOptions({ query: { companyId } }),
      ON_DEMAND_QUERY_OPTIONS,
    ),
  );

  return (
    <QueryResult query={query} label="factures">
      {({ invoices }): JSX.Element =>
        invoices.length === 0 ? (
          <Message>Il n&apos;y a pas de factures</Message>
        ) : (
          <Table basic="very" compact selectable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Date</Table.HeaderCell>
                <Table.HeaderCell>N° facture</Table.HeaderCell>
                <Table.HeaderCell>Montant HT</Table.HeaderCell>
                <Table.HeaderCell>Montant TTC</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  Télécharger
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {invoices.map((invoice) => (
                <Table.Row
                  key={pennylaneKeyOf(
                    invoice.billingIssuerId,
                    invoice.invoiceNumber,
                  )}
                >
                  <Table.Cell>
                    {formatCalendarDate(invoice.issuedOn)}
                  </Table.Cell>
                  <Table.Cell>{invoice.invoiceNumber}</Table.Cell>
                  <Table.Cell>{formatAmount(invoice.amount)}</Table.Cell>
                  <Table.Cell>{formatAmount(invoice.amountWithTax)}</Table.Cell>
                  <Table.Cell>
                    <InvoiceStatusLabel status={invoice.status} />
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    <InvoiceFileButton
                      billingIssuerId={invoice.billingIssuerId}
                      invoiceNumber={invoice.invoiceNumber}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )
      }
    </QueryResult>
  );
};
